import { __rest as m, __assign as c } from "../../../tslib/tslib.es6.js";
import * as o from "react";
import { RemoveScroll as I } from "../../node_modules/react-remove-scroll/dist/es2015/UI.js";
import x from "../../../react-focus-lock/dist/es2015/Lock.js";
import { effectCar as T } from "./medium.js";
var V = { preventScroll: !0 }, G = o.forwardRef(function(e, v) {
  var n = o.useState(!1), a = n[0], F = n[1], f = e.children, h = e.autoFocus, r = e.shards, L = e.crossFrame, l = e.enabled, s = l === void 0 ? !0 : l, i = e.scrollLock, k = i === void 0 ? !0 : i, d = e.focusLock, P = d === void 0 ? !0 : d, u = e.returnFocus, _ = u === void 0 ? !0 : u, g = e.inert, C = e.allowPinchZoom, t = e.sideCar, S = e.className, b = e.shouldIgnore, w = e.preventScrollOnFocus, O = e.style, E = e.as, N = e.gapMode, y = m(e, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]), A = t, D = a.onActivation, M = a.onDeactivation, R = m(a, ["onActivation", "onDeactivation"]), Z = c(c({}, R), {
    as: E,
    style: O,
    sideCar: t,
    shards: r,
    allowPinchZoom: C,
    gapMode: N,
    inert: g,
    enabled: s && k
  });
  return o.createElement(
    o.Fragment,
    null,
    o.createElement(x, { ref: v, sideCar: t, disabled: !(a && s && P), returnFocus: _, autoFocus: h, shards: r, crossFrame: L, onActivation: D, onDeactivation: M, className: S, whiteList: b, lockProps: Z, focusOptions: w ? V : void 0, as: I }, f),
    s && o.createElement(A, c({}, y, { sideCar: T, setLockProps: F, shards: r }))
  );
});
export {
  G as FocusOn
};
//# sourceMappingURL=UI.js.map
